import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {
  productSelector,
  addToCart,
  changeOption,
  watchPrice
} from "../../ducks/product";
import {reviewsSelector} from "../../ducks/reviews";
import {openModal} from "../../ducks/buy-in-one-click";
import Grid from "@material-ui/core/Grid";
import Badges from "../Badges";
import Price from "../../../common/Price";
import Options from "../../../common/Options";
import Button from "../../../common/Button";
import Author from "../Author";
import Tags from "../Tags";
import Quantity from "../Quantity";
import withErrorBoundary from "../../../../decorators/withErrorBoundary";

import styles from "./bar.module.scss";

function Bar(props) {
  const {
    product: {
      id,
      singular,
      department,
      category,
      description,
      name,
      path,
      title,
      badges,
      licensedProduct,
      condition: {
        options: currentOptions,
        price: {basePrice, currentPrice},
        disabled
      },
      options,
      views,
      banned,
      circulations
    },
    reviews
  } = props;
  const image = views && views.large ? views.large[0] : ``;
  const date = new Date();
  const sevenDaysFromNow = new Date(date.setDate(date.getDate() + 7));

  return (
    <Grid container className={styles.root}>
      <Grid item xs={12}>
        <h1 itemProp="name" className={styles.title}>
          {name} {title} #{id}
        </h1>
        {description ? (
          <meta itemProp="description" content={description} />
        ) : (
          <meta itemProp="description" content={name} />
        )}
        <meta itemProp="image" content={image} />
        <meta itemProp="sku" content={id} />
        <meta itemProp="mpn" content={id} />
        <meta itemProp="brand" content="printio" />
        {reviews.content.length ? (
          <div
            className="hidden"
            itemProp="aggregateRating"
            itemScope
            itemType="http://schema.org/AggregateRating"
          >
            <span itemProp="ratingValue">5</span>
            <span itemProp="bestRating">5</span>
            <span itemProp="worstRating">5</span>
            <span itemProp="reviewCount">3</span>
          </div>
        ) : null}
        {reviews.content.length
          ? reviews.content.map(({id: reviewId, comments, author}) => (
              <div
                key={reviewId}
                className="hidden"
                itemProp="review"
                itemScope
                itemType="http://schema.org/Review"
              >
                <meta itemProp="reviewBody" content={comments} />
                <div
                  itemProp="reviewRating"
                  itemScope
                  itemType="http://schema.org/Rating"
                >
                  <meta itemProp="ratingValue" content="5.0" />
                </div>
                <meta itemProp="author" content={author} />
              </div>
            ))
          : null}
      </Grid>
      <Grid item xs={12} className={styles.badges}>
        <Badges badges={badges} />
      </Grid>
      <Grid item xs={12} className={styles.prices}>
        <Price
          basePrice={basePrice}
          currentPrice={currentPrice}
          buttonAction={props.watchPrice}
          buttonText="Следить за ценой"
        />
      </Grid>
      {circulations && (
        <Grid item xs={12} className={styles.quantity}>
          <Quantity/>
        </Grid>
      )}
      <Grid
        item
        xs={12}
        className={styles.options}
        itemProp="offers"
        itemScope
        itemType="http://schema.org/Offer"
      >
        <Options
          productName={singular}
          department={department}
          category={category}
          options={options}
          currentOptions={currentOptions}
          changeOption={props.changeOption}
        />
        <link itemProp="availability" href="http://schema.org/InStock" />
        <meta itemProp="url" content={path} />
        <meta
          itemProp="itemCondition"
          content="http://schema.org/NewCondition"
        />
        <meta itemProp="image" content={image} />
        <meta itemProp="priceValidUntil" content={sevenDaysFromNow} />
        <meta itemProp="priceCurrency" content="RUB" />
        <meta itemProp="price" content={currentPrice} />
      </Grid>
      <Grid item xs={12} className={styles.order}>
        {banned ? (
          <Button
            variant="contained"
            style="primary"
            size="large"
            href={`/${category}/new_v2`}
          >
            Перейти в редактор
          </Button>
        ) : (
          <>
            {!licensedProduct && (
              <Button
                disabled={disabled}
                variant="contained"
                style="primary"
                size="large"
                onClick={props.addToCart}
              >
                {disabled ? `Нет на складе` : `В корзину`}
              </Button>
            )}
            <Button
              disabled={disabled}
              variant="contained"
              style="secondary"
              size="large"
              onClick={props.showBuyInOneClickPopup}
            >
              Купить в 1 клик
            </Button>
          </>
        )}
      </Grid>
      <Grid item xs={12} className={styles.author}>
        <Author />
      </Grid>
      <Grid item xs={12} className={styles.tags}>
        <Tags />
      </Grid>
    </Grid>
  );
}

Bar.propTypes = {
  product: PropTypes.object,
  addToCart: PropTypes.func,
  showBuyInOneClickPopup: PropTypes.func,
  changeOption: PropTypes.func,
  watchPrice: PropTypes.func,
  reviews: PropTypes.object
};

const mapStateToProps = (state) => ({
  product: productSelector(state),
  reviews: reviewsSelector(state)
});

const mapDispatchToProps = {
  changeOption,
  addToCart,
  showBuyInOneClickPopup: openModal,
  watchPrice
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(Bar));
